module.exports = __webpack_public_path__ + "img/red_top.02c8a456.png";